import React from 'react';
import PropTypes from 'prop-types';

function NoDebitCard({ onAdd }) {
  return (
    <div>
      <div className="o-tableize">
        <div className="o-tableize__cell">
          <button
            className="c-btn u-mt0"
            onClick={onAdd}
          >
            Add Debit Card
          </button>
        </div>
        <div className="o-tableize__cell u-pl">
          <div className="c-heading c-heading--small" style={{ marginTop: -6 }}>
            Adding a debit card associated with the above checking account is required to receive
            rapid transfers. Please make sure you enter the right debit card number to ensure that the
            payouts are made to the right account.
          </div>
        </div>
      </div>
    </div>
  );
}

NoDebitCard.propTypes = {
  onAdd: PropTypes.func.isRequired,
};

export default NoDebitCard;
